import ReactDOMServer from "react-dom/server";

export const toBase64 = (el: React.ReactElement) => 
  Buffer.from(ReactDOMServer.renderToString(el))
  .toString('base64')
